export const initialState = {
  documentTemplate: {
    changed: false,
    signatureBookmarksChanged: false,
    documentTemplateXOptionBookmarksChanged: false
  }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnDocumentTemplateXSignaturesChanged':
      return onDocumentTemplateXSignaturesChanged(state, action);
    case 'onDocumentTemplateSignaturePropertyChanged':
      return onDocumentTemplateSignaturePropertyChanged(state, action);
    case 'OnDocumentTemplateXSignaturesSaved':
      return onDocumentTemplateXSignaturesSaved(state);
    case 'OnNewBookmarkAdded':
      return onNewBookmarkAdded(state, action);
    case 'OnNewDocumentTemplateXOptionBookmarkAdded':
      return onNewDocumentTemplateXOptionBookmarkAdded(state, action);
    case 'OnBookmarkDeleted':
      return onBookmarkDeleted(state, action);
    case 'OnDocumentTemplateXOptionBookmarkDeleted':
      return onDocumentTemplateXOptionBookmarkDeleted(state, action);
    case 'OnSignatureBookmarkChanged':
      return onSignatureBookmarkChanged(state, action);
    case 'OnDocumentTemplateXOptionBookmarkChanged':
      return onDocumentTemplateXOptionBookmarkChanged(state, action);
    case 'OnSignatureBookmarkActorChanged':
      return onSignatureBookmarkActorChanged(state, action);
    case 'OnSignatureBookmarksUpdated':
      return onSignatureBookmarksUpdated(state, action);
    case 'OnDocumentTemplateXOptionBookmarksUpdated':
      return onDocumentTemplateXOptionBookmarksUpdated(state, action);
    default:
      return state;
  }
}

function onInitState(state, action) {
  const { docTemplate } = action;
  let initState = {
    ...state,
    documentTemplate: {
      ...docTemplate,
      changed: false,
      signatureBookmarksChanged: false,
      documentTemplateXOptionBookmarksChanged: false
    }
  };
  initState = generateStateBookmarks(initState);
  initState = generateStateDocumentTemplateXOptionBookmarks(initState);
  return initState;
}

function onBookmarkDeleted(state, action) {
  const { index } = action;
  const bookmarks = Object.assign([...state.documentTemplate.signatureBookmarks]);
  bookmarks.splice(index, 1);
  return {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      signatureBookmarks: bookmarks,
      signatureBookmarksChanged: true
    }
  };
}

function onDocumentTemplateXOptionBookmarkDeleted(state, action) {
  const { index } = action;
  const bookmarks = Object.assign([...state.documentTemplate.documentTemplateXOptionBookmarks]);
  bookmarks.splice(index, 1);
  return {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      documentTemplateXOptionBookmarks: bookmarks,
      documentTemplateXOptionBookmarksChanged: true
    }
  };
}

function onNewBookmarkAdded(state, action) {
  const newBookmark = {
    templateId: action.templateId,
    id: null,
    name: '',
    isTable: false,
    signatureBookmarkActors: []
  };
  const newBookmarks = Object.assign([...state.documentTemplate.signatureBookmarks]);
  newBookmarks.push({ ...newBookmark });
  return {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      signatureBookmarks: newBookmarks,
      signatureBookmarksChanged: true
    }
  };
}
function onNewDocumentTemplateXOptionBookmarkAdded(state, action) {
  const newBookmarkOption = {
    templateId: action.templateId,
    id: null,
    bookmarkName: '',
    dataSource: null
  };
  const newOptionBookmarks = Object.assign([...state.documentTemplate.documentTemplateXOptionBookmarks]);
  newOptionBookmarks.push({ ...newBookmarkOption });
  return {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      documentTemplateXOptionBookmarks: newOptionBookmarks,
      documentTemplateXOptionBookmarksChanged: true
    }
  };
}
const onDocumentTemplateXSignaturesChanged = (state, action) => {
  const { documentTemplateXSignatures } = action;
  return {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      documentTemplateXSignatures: Object.assign([...documentTemplateXSignatures]),
      documentTemplateXSignaturesChanged: true
    }
  };
};

function onSignatureBookmarkChanged(state, action) {
  const { propName, propValue, index } = action;
  let newState = {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      signatureBookmarks: Object.assign([...state.documentTemplate.signatureBookmarks], {
        [index]: {
          ...state.documentTemplate.signatureBookmarks[index],
          [propName]: propValue
        }
      }),
      signatureBookmarksChanged: true
    }
  };
  newState = generateStateBookmarks(newState, false);
  return newState;
}

function onDocumentTemplateXOptionBookmarkChanged(state, action) {
  const { propName, propValue, index } = action;
  let newState = {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      documentTemplateXOptionBookmarks: Object.assign([...state.documentTemplate.documentTemplateXOptionBookmarks], {
        [index]: {
          ...state.documentTemplate.documentTemplateXOptionBookmarks[index],
          [propName]: propValue
        }
      }),
      documentTemplateXOptionBookmarksChanged: true
    }
  };
  newState = generateStateDocumentTemplateXOptionBookmarks(newState);
  return newState;
}

function generateStateBookmarks(state) {
  let a = JSON.parse(JSON.stringify(state));
  a.documentTemplate.signatureBookmarks.forEach(x => {
    x.generatedBookmarks = [
      `#${x.name}_ROLE#`,
      `#${x.name}_POSITION#`,
      `#${x.name}_FIRSTNAME#`,
      `#${x.name}_LASTNAME#`,
      `#${x.name}_SIGNATURE#`
    ];
    if (x.isTable) x.generatedBookmarks.push(`#${x.name}#`);
  });
  return a;
}

function generateStateDocumentTemplateXOptionBookmarks(state) {
  let newState = JSON.parse(JSON.stringify(state));
  newState.documentTemplate.documentTemplateXOptionBookmarks.forEach(x => {
    x.generatedBookmarks = [`#${x.bookmarkName}_BUTTON#`, `#${x.bookmarkName}_OPTIONNAME#`, `#${x.bookmarkName}#`];
  });
  return newState;
}

function onSignatureBookmarkActorChanged(state, action) {
  const { signatureActors, index } = action;
  return {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      signatureBookmarks: Object.assign([...state.documentTemplate.signatureBookmarks], {
        [index]: {
          ...state.documentTemplate.signatureBookmarks[index],
          signatureBookmarkActors: signatureActors
        }
      }),
      signatureBookmarksChanged: true
    }
  };
}

const onDocumentTemplateSignaturePropertyChanged = (state, action) => {
  const { propertyName, value } = action;
  return {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      [propertyName]: value,
      documentTemplateXSignatures: Object.assign([...state.documentTemplate.documentTemplateXSignatures]),
      documentTemplateXSignaturesChanged: true
    }
  };
};

const onDocumentTemplateXSignaturesSaved = state => {
  return {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      documentTemplateXSignaturesChanged: false
    }
  };
};

const onSignatureBookmarksUpdated = (state, action) => {
  let updatedState = {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      signatureBookmarks: action.signatureBookmarks,
      signatureBookmarksChanged: false
    }
  };
  updatedState = generateStateBookmarks(updatedState);
  return updatedState;
};

const onDocumentTemplateXOptionBookmarksUpdated = (state, action) => {
  let updatedState = {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      documentTemplateXOptionBookmarks: action.documentTemplateXOptionBookmarks,
      documentTemplateXOptionBookmarksChanged: false
    }
  };
  updatedState = generateStateDocumentTemplateXOptionBookmarks(updatedState);
  return updatedState;
};
